import YesNoButtons from "./YesNoButtons"

export default YesNoButtons
